<template>
  <div class="card" style="padding-bottom:0rem">
    <div class="card-title">
      <span class="title-new">&nbsp;</span>
      订阅人员
    </div>
    <div class="bind-list">
      <div class="bind-list-item bind-mb">
        <div class="bind-t-1" style="color: #1A1A1A;width:7rem;padding-left:1.7rem">
          订阅人
        </div>
        <div class="bind-t-2" style="color: #1A1A1A;">
          绑定手机号
        </div>
        <div class="bind-t-3" v-show="isAdd">
          <!-- <div class="add">添加</div> -->
        </div>
      </div>
      <van-checkbox-group style="width: 100%;" v-model="radio">
        <div class="bind-list-item" v-for="(item, index) in personData" :key="index">
          <div class="bind-t-1" style="width:7rem">
            <div v-if="type == 'detail'">{{ item.name }}</div>
            <van-checkbox :name="item" v-else shape="square" ref="checkboxes">
              {{ item.name }}
            </van-checkbox>
          </div>
          <div class="bind-t-2">
            {{ item.mobile }}
          </div>
          <div class="bind-t-3">
            <div class="bind-t-3"></div>
          </div>
        </div>
      </van-checkbox-group>
      <div class="bind-list-item" v-for="(item, index) in bindDetail" :key="index">
        <div class="bind-t-1">
          <van-checkbox-group style="width: 100%;" v-model="radio2">
            <van-checkbox :name="item" shape="square" ref="checkboxes">
              <!-- {{ item.bandingUserName }} -->
              <van-field v-model="item.bandingUserName" placeholder="填写姓名" />
            </van-checkbox>
          </van-checkbox-group>
        </div>
        <div class="bind-t-2">
          <!-- {{ item.bandingUserPhone }} -->
          <van-field v-model="item.bandingUserPhone" type="tel" placeholder="填写手机号" maxlength="11" />
        </div>
        <div class="bind-t-3" @click="delPersonData(item)" v-show="type !== 'detail'">
          <img src="../../assets/del.png" alt="" />
        </div>
      </div>
      <div class="bind-list-item" v-show="type !== 'detail'">
        <div class="bind-t-1" style="color: #454f63;width:7rem;">
          <van-row>
            <van-col :span="6">
              <!-- <van-checkbox-group style="width: 100%;" v-model="radio3">
                <van-checkbox :name="form"  shape="square" ref="checkboxes" @click="select">
                </van-checkbox>
              </van-checkbox-group> -->
            </van-col>
            <van-col :span="16"><van-field v-model="form.bandingUserName" placeholder="填写姓名"/></van-col>
          </van-row>
        </div>
        <div class="bind-t-2">
          <van-field v-model="form.bandingUserPhone" type="tel" maxlength="11" placeholder="填写手机号" />
        </div>
        <div class="bind-t-3" @click="changeAddPersonData()">
          <van-icon name="add-o" color="#78849E" size="1.2rem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPhone } from "@/utils/validate.js";
export default {
  // props: ['comboItem', 'isAdd'],
  props: {
    patriarchUserId: "",
    peopleNum: 0,
    childId: {},
    footShow: {},
    isAdd: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    type: {},
  },
  data() {
    return {
      personData: [],
      addPersonData: [],
      radio: [],
      v: [],
      form: {},
      bindDetail: [],
      radio2: [],
      radio3: [],
      docmHeight: document.documentElement.clientHeight, // 默认屏幕高度
      showHeight: document.documentElement.clientHeight, // 实时屏幕高度
    };
  },
  mounted() {
    if (localStorage.getItem("shopping_cart") && JSON.parse(localStorage.getItem("shopping_cart")).person.length > 0 && this.type !== "detail") {
      this.addPersonData = JSON.parse(sessionStorage.getItem("shopping_cart")).person;
    }
    this.getParentsList();
    let vm = this;
    // window.resize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })();
    };
  },
  computed: {
    userInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
    overallData() {
      return [...this.addPersonData, ...this.bindDetail];
    },

    // isBindPerson() {
    //   return (
    //     // 当前自定义输入的 == 人数 -1
    //     this.addPersonData.filter((item) => item.isShowList).length ==
    //     this.peopleNum - 1
    //   )
    // },
  },
  watch: {
    showHeight: function() {
      if (this.docmHeight > this.showHeight) {
        this.$emit("focusFootShow", false);
      } else {
        this.$emit("focusFootShow", true);
      }
    },
    childId(n) {
        console.log('child',n);
      this.radio = [];
      this.addPersonData = [];
      this.getParentsList();
    },
    radio(n, o) {
      console.log(n, o, "radio");
      // 先除去之前的，再更新当前的
      if (o.length > 0) {
        var set = o.map((item) => item.id);
        this.addPersonData = this.addPersonData.filter((item) => !set.includes(item.bandingUserId));
      }
      n.forEach((item) => {
        this.addPersonData.push(this.personItemData(item));
      });
      console.log("我是addPersonData",this.addPersonData);
      // if (this.addPersonData.length + 1 < this.peopleNum) {

      // }
    },
    radio2(n, o) {
      if (o.length > 0) {
        var set = o.map((item) => item.id);
        this.addPersonData = this.addPersonData.filter((item) => !set.includes(item.bandingUserId));
      }
      console.log("我是n");
      console.log(n);
      n.forEach((obj) => {
        this.addPersonData.push({ bandingUserName: obj.bandingUserName, bandingUserPhone: obj.bandingUserPhone, isShowList: obj.isShowList });
      });
      console.log("我是addPersonData");
      console.log(this.addPersonData);
    },
  },
  methods: {
    personItemData(obj) {
      return {
         bandingUserName: obj.name,
        bandingUserId: obj.id,
        schoolId: obj.schoolId,
        bandingUserPhone: obj.mobile,
        isShowList: obj.isShowList,
      };
    },
    select() {
      console.log("form", this.radio3.length);
    },
    handleChangeCheckbox(names) {
      console.log(names);
    },
    async getSubPersonList(num) {
      try {
        const { code, data } = await this.$https.getSubPersonList({
          //schoolId: this.$store.state.pschoolId,
          orderNum: num,
        });
        if (code !== 200) {
          return false;
        }
        this.addPersonData = data.filter((item) => item.bandingUserId !== JSON.parse(localStorage.getItem("userInfo")).patriarchUserId);
      } catch (error) {}
    },
    async getParentsList() {
      try {
        const { code, data } = await this.$https.getParentsList({
          // parentsId: JSON.parse(localStorage.getItem('userInfo'))
          //   .patriarchUserId,
          childId: this.childId,
        });
        if (code !== 200) {
          return false;
        }

        this.personData = data.map((item) => {
          console.log(item, "item", this.patriarchUserId, "前");
          if (item.id === this.patriarchUserId) {
            console.log(item, "item", this.patriarchUserId, "后");
            this.radio.push(item);
            // this.addPersonData.push(this.personItemData(item))
          }
          item.isShowList = false;
          return item;
        });
      } catch (error) {}
    },

    delPersonData(itemData) {
      console.log(itemData);
      console.log(this.radio2);
      let zhi = true;
      for (let i = 0; i < this.radio2.length; i++) {
        if (itemData.bandingUserPhone == this.radio2[i].bandingUserPhone) {
          this.$toast("请先取消选中此人员");
          zhi = false;
          break;
        }
      }
      // this.radio2.forEach((val,index)=>{

      // })
      if (!zhi) {
        return;
      }
      //bandingUserPhone
      // this.radio2.forEach((val,index)=>{
      //   if(val.)
      // })
      const index = this.bindDetail.findIndex((item) => item.bandingUserPhone === itemData.bandingUserPhone);
      const index2 = this.addPersonData.findIndex((item) => item.bandingUserPhone === itemData.bandingUserPhone);
      this.addPersonData.splice(index2, 1);
      this.bindDetail.splice(index, 1);
      console.log(this.radio2);
    },
    changeAddPersonData() {
      // console.log(this.peopleNum);
      // console.log(this.bindDetail.length+this.personData.length);
      // console.log(this.bindDetail);
      // if(this.bindDetail.length+this.personData.length==(Number(this.peopleNum)-1)){
      //   this.$toast('订阅人数仅限'+this.peopleNum+'人')
      //   return;
      // }
      // console.log(this.personData);
      // return;
      if (!this.form.bandingUserName || !this.form.bandingUserPhone) {
        this.$toast("请填写信息");
        return;
      }
      if (!isPhone(this.form.bandingUserPhone)) {
        this.$toast("手机号输入有误");
        return;
      }
      let isExist;
      let isNorExist;
      let bindIndex;
      let pDateIndex;
      let zhi = [...this.personData, ...this.bindDetail];
      let tt = zhi.map((ct) => {
        return (ct.mobile = ct.mobile ? ct.mobile : ct.bandingUserPhone);
      });
      // if (this.bindDetail.length > 0) {
      //   isExist = this.bindDetail.some(
      //     (data,index) => {
      //       if(data.bandingUserPhone == this.form.bandingUserPhone){
      //         bindIndex=index;
      //         return true;
      //       }else{
      //         return false;
      //       }
      //     })
      // }
      // if (this.personData.length > 0) {
      //   isNorExist = this.personData.some(
      //     (data,index) => {
      //       if(data.mobile == this.form.bandingUserPhone){
      //         pDateIndex=index;
      //         return true;
      //       }else{
      //         return false;
      //       }
      //       // data.mobile == this.form.bandingUserPhone
      //     })
      // }
      console.log("我是tt");
      console.log(tt);
      let boolean = false;
      tt.forEach((data, index) => {
        if (data == this.form.bandingUserPhone) {
          pDateIndex = index;
          boolean = true;
          console.log("有重复的进来了mobile");
        }
      });
      console.log("我是zhi");
      console.log(zhi);
      if (boolean) {
        this.$toast("当前手机号与第" + (pDateIndex + 1) + "行手机号重复");
        return false;
      }

      // if (isExist||isNorExist) {
      //   this.$toast('手机号已存在，请勿重复添加')
      //   return false
      // }
      // if (this.addPersonData.length + 1 >= this.peopleNum) {
      //   return this.$toast('人员超过限制，尝试更换套餐')
      // }
      this.bindDetail.push({
        ...this.form,
        isShowList: false,
      });
      this.radio3 = [];
      this.form = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: block;
  .card-title {
    color: #1a1a1a;
    font-size: 0.88rem;
    padding: 1.06rem;
    padding-bottom: 0.5rem;
    /* padding-top: 0; */
    .title-new {
      height: 0.5rem;
      padding: 0.1rem;
      background: #37a5da;
      margin-right: 0.2rem;
    }
  }
  .bind-list {
    padding: 0.3rem 1.5rem;
    padding-right: 1.5rem;

    color: #454f63;
    .bind-list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.9rem;
      &.bind-mb {
        margin-bottom: 1.19rem;
      }
      .bind-t-1 {
        width: 7rem;
        text-align: left;
        font-size: 0.85rem;
        color: #1a1a1a;
        ::v-deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-2 {
        width: 7rem;
        text-align: left;
        font-size: 0.85rem;
        color: #1a1a1a;
        ::v-deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-3 {
        /* width: 5rem; */
        text-align: center;
        width: 3.31rem;
        img {
          width: 1.05rem;
          height: 1.05rem;
        }
        .add {
          border: 0.06rem solid #e2bd78;
          border-radius: 0.75rem;
          width: 3.31rem;
          height: 1.25rem;
          text-align: center;
          line-height: 1.25rem;
          font-size: 0.88rem;
          color: #c28f22;
        }
      }
    }
  }
}
</style>
